import React from 'react';
import ActionContactInfo from '../contact-info-action';

const BuildContactInfoAction = props => <ActionContactInfo {...props} />;

export default BuildContactInfoAction;
